import styled from 'styled-components';

/** Asiakaskortin oma lohko: otsikko erottuu leipätekstistä ja lohkot eivät juokse yhteen. */
export const Osio = styled.section`
  margin-top: 14px;
  padding: 12px 14px 14px;
  border: 1px solid ${p => p.theme.color.line};
  border-radius: 10px;
  background: ${p => p.theme.color.bg};
  > h4 {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
    color: ${p => p.theme.color.ink};
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
`;
